import { render, staticRenderFns } from "./lucky_login.vue?vue&type=template&id=baa2a432&scoped=true&"
import script from "./lucky_login.vue?vue&type=script&lang=js&"
export * from "./lucky_login.vue?vue&type=script&lang=js&"
import style0 from "./lucky_login.vue?vue&type=style&index=0&id=baa2a432&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa2a432",
  null
  
)

export default component.exports